import { Http, Headers, RequestOptions, RequestOptionsArgs } from '@angular/http';
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/toPromise';
import { Observable } from 'rxjs/Observable';
import { map, catchError, finalize } from 'rxjs/operators';
import * as _ from 'lodash';
import { LoadingService } from './loading.service';

@Injectable()
export class RestService {
  public  serverError = false;
  protected baseUrl = 'http://local.unicorn.vn:44336';
  protected hostUrl = window.location.origin;

  constructor(private _http: Http, private loadingService: LoadingService) { }

  protected getHeaders(header:any) {
    const headers = new Headers();
    const token: string = localStorage.getItem('token');
    
    _.set(headers, 'Authorization', 'Bearer ' + token);
    _.set(headers, 'Content-Type', 'application/json');
    _.merge(headers, header);
    return headers;
  }

  protected get(relativeUrl: string, isSelfHosted: boolean = false, header: any = {}): Observable<any> {
    const url = !isSelfHosted ? this.baseUrl + relativeUrl : this.hostUrl + relativeUrl;
    this.loadingService.show();
    return this._http.get(url, {
      headers: this.getHeaders(header)
    }).pipe(
      map(res => res.json()),
      catchError((err) => {
        this.serverError = true;
        throw err;
      }),
      finalize(() => this.loadingService.hide())
    );
  }

  protected post(relativeUrl: string, data: any, isSelfHosted: boolean = false, header: any = {}): Observable<any> {
    const url = !isSelfHosted ? this.baseUrl + relativeUrl : this.hostUrl + relativeUrl;
    const options: RequestOptionsArgs = {
      method: 'POST',
      headers: this.getHeaders(header),
      body: data
    };
    this.loadingService.show();
    return this._http.request(url, options).pipe(
      map(res => res.json()),
      catchError((err) => {
        this.serverError = true;
        throw err;
      }),
      finalize(() => this.loadingService.hide())
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/core/rest.service.ts